<template>
  <login-layout>
    <h1 slot="title" class="my-3">
      {{ $t('Restaurar contraseña') }}
    </h1>
    <template slot="content">
      <reset-password-form></reset-password-form>
    </template>
  </login-layout>
</template>

<script>
import ResetPasswordForm from '../components/ResetPasswordForm';
import LoginLayout from '../components/LoginLayout.vue';
export default {
  components: {
    ResetPasswordForm,
    LoginLayout,
  },
};
</script>

<style></style>
